import { render, staticRenderFns } from "./LegalExpertUser.vue?vue&type=template&id=7229a970&scoped=true"
import script from "./LegalExpertUser.vue?vue&type=script&lang=js"
export * from "./LegalExpertUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229a970",
  null
  
)

export default component.exports